export default "__VITE_ASSET__khhSpY0x__"